import CookiesPopup from '@kiwicom/nitro/lib/components/CookiesPopup';
import { useFeature } from '@kiwicom/darwin';

const CookiesPopupModal = () => {
  const shouldShowRejectAllButton = useFeature('COOKIE_CONSENT_REJECTALL');

  return <CookiesPopup disableAnimation showRejectAll={shouldShowRejectAllButton} />;
};

export default CookiesPopupModal;
